/*
  Hawaiian Macadamia Nut Services
  Alexander Self
  routes.js: Main client-side routing used throughout the application
  For authorization over a nested route, use RequireAuth in the parent route
*/

import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AuthApp from './containers/auth_app';
import SignIn from './containers/auth/signin';
import SignOut from './containers/auth/signout';
import RequireAuth from './containers/auth/require_auth';
import Main from './containers/main';
import Dashboard from './containers/dashboard';

/* Timesheet Components */
import Timesheet from './containers/timesheet';
import TimesheetView from './components/timesheets/view/timesheet_view';
import TimesheetCreate from './components/timesheets/create/timesheet_create';
import TimesheetEdit from './components/timesheets/edit/timesheet_edit';
import TimesheetDelete from './components/timesheets/delete/timesheet_delete';

/* Team Builder Components */
import TeamBuilder from './containers/team_builder';
import TeamView from './components/teams/view/team_view';
import TeamCreate from './components/teams/create/team_create';
import TeamEdit from './components/teams/edit/team_edit';
import TeamDelete from './components/teams/delete/team_delete';

/* Profile Components */
import Profile from './containers/profile';
import ProfileView from './components/profiles/view/profile_view';
import ProfileCreate from './components/profiles/create/profile_create';
import ProfileEdit from './components/profiles/edit/profile_edit';
/* Alert Component */
import Alert from './containers/alert';

/* Mechanical Harvest Components */
import Harvest from './containers/harvest';
import HarvestView from './components/harvest/view/harvest_view';
import MechanicalHarvestCreate from './components/harvest/create/mechHarvest_create';
import MechanicalHarvestManage from './components/harvest/manage/mechHarvest_manage';

/* Cultivation Components */
import Cultivation from './cultivation';
import CultivationIntro from './cultivation/components/documentation/introduction';
import Reports from './cultivation/components/reports/reports';
import ChemicalContainer from './cultivation/components/chemical/chemical_container';
import ChemicalView from './cultivation/components/chemical/chemical_view';
import ChemicalApplicationContainer from './cultivation/components/chem_app/chem_app_container';
import ChemicalApplicationView from './cultivation/components/chem_app/chem_app_view';
import ChemicalApplicationCreate from './cultivation/components/chem_app/chem_app_create';
import FertilizerContainer from './cultivation/components/fertilizer/fertilizer_container';
import FertilizerCreate from './cultivation/components/fertilizer/fertilizer_create';
import FertilizerView from './cultivation/components/fertilizer/fertilizer_view';
import MowingContainer from './cultivation/components/mowing/mowing_container';
import MowingCreate from './cultivation/components/mowing/mowing_create';
import MowingView from './cultivation/components/mowing/mowing_view';
import TreeReplantContainer from './cultivation/components/tree_replant/tree_replant_container';
import TreeInventory from './cultivation/components/tree_replant/tree_inventory';
import TreeReplant from './cultivation/components/tree_replant/tree_replant';

/* Weather Component */
import Weather from './weather/weather';

/* Irrigation Components */
import IrrigationContainer from './irrigation/irrigation_container';
import IrrigationView from './irrigation/irrigation_view';
import IrrigationCreate from './irrigation/irrigation_create';
import IrrigationManage from './irrigation/irrigation_manage';

/* Interval Components */
import IntervalContainer from './interval/interval_container'
import IntervalView from './interval/interval_view'

export default (
  <Route>
    <Route path="/" component={AuthApp}>
      <IndexRoute component={SignIn} />
      <Route path="/signout" component={SignOut} />
    </Route>

    <Route path="/dashboard" component={RequireAuth(Main)}>
      {/**************** DASHBOARD *****************/}
      <IndexRoute component={Dashboard} />
      {/**************** TIMESHEETS ****************/}
      <Route path="/timesheet" component={Timesheet}>
        <IndexRoute component={TimesheetView} />
        <Route path="/timesheet/create" component={TimesheetCreate} />
        <Route path="/timesheet/edit" component={TimesheetEdit} />
        <Route path="/timesheet/delete" component={TimesheetDelete} />
      </Route>
      {/***************** GANG BUILDER ******************/}
      <Route path="/teambuilder" component={TeamBuilder}>
        <IndexRoute component={TeamView} />
        <Route path="/teambuilder/create" component={TeamCreate} />
        <Route path="/teambuilder/edit" component={TeamEdit} />
        <Route path="/teambuilder/delete" component={TeamDelete} />
      </Route>
      {/**************** PROFILES *****************/}
      <Route path="/profile" component={Profile}>
        <IndexRoute component={ProfileView} />
        <Route path="/profile/create" component={ProfileCreate} />
        <Route path="/profile/edit" component={ProfileEdit} />
      </Route>
      {/**************** SMS *****************/}
      <Route path="/alert" component={Alert}>
        <IndexRoute component={Alert} />
      </Route>
      {/**************** MECH HARVEST *****************/}
      <Route path="/harvest" component={Harvest}>
        <IndexRoute component={HarvestView} />
        <Route path="/harvest/create" component={MechanicalHarvestCreate} />
        <Route path="/harvest/manage" component={MechanicalHarvestManage} />
      </Route>
      {/**************** CULTIVATION *****************/}
      <Route path="/cultivation" component={Cultivation}>
        <IndexRoute component={CultivationIntro} />
        {/************* Products and Reports *************/}
        <Route path="/cultivation" component={ChemicalContainer}>
          <Route path="/cultivation/products" component={ChemicalView} />
          <Route path="/cultivation/reports" component={Reports} />
        </Route>
        {/************* Chemical Application(Herb, Pest, etc) *************/}
        <Route path="/cultivation/chemicalApplication" component={ChemicalApplicationContainer}>
          <IndexRoute component={ChemicalApplicationView} />
          <Route path="/cultivation/chemicalApplication/create" component={ChemicalApplicationCreate} />
        </Route>
        {/************* Fertilizer Applications *************/}
        <Route path="/cultivation/fertilizer" component={FertilizerContainer}>
          <IndexRoute component={FertilizerView} />
          <Route path="/cultivation/fertilizer/create" component={FertilizerCreate} />
        </Route>
        {/************* Mowing Work *************/}
        <Route path="/cultivation/mowing" component={MowingContainer}>
          <IndexRoute component={MowingView} />
          <Route path="/cultivation/mowing/create" component={MowingCreate} />
        </Route>
        {/************* Tree Inventory and Replanting *************/}
        <Route path="/cultivation" component={TreeReplantContainer}>
          <Route path="/cultivation/trees" component={TreeInventory} />
          <Route path="/cultivation/replants" component={TreeReplant} />
        </Route>
      </Route>
      {/* END Cultivation */}
      <Route path="/irrigation" component={IrrigationContainer}>
        <IndexRoute component={IrrigationView} />
        <Route path="/irrigation/create" component={IrrigationCreate} />
        <Route path="/irrigation/manage" component={IrrigationManage} />
      </Route>
      <Route path="/weather" component={Weather}></Route>
      <Route path="/interval" component={IntervalContainer}>
        <IndexRoute component={IntervalView} />
      </Route>
    </Route>

  </Route>
)

/* END */



// WEBPACK FOOTER //
// ./src/routes.js